module.exports = __webpack_public_path__ + "img/vol05_character_thumb02.4a4fa992.png";